import { render, staticRenderFns } from "./RoomConfigDialog.vue?vue&type=template&id=64d6259e&scoped=true"
import script from "./RoomConfigDialog.vue?vue&type=script&lang=js"
export * from "./RoomConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./RoomConfigDialog.vue?vue&type=style&index=0&id=64d6259e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6259e",
  null
  
)

export default component.exports